module.exports = __webpack_public_path__ + "src/assets/img/car_location.773f559e.jpg";